const de = {
  nav: {
    home: "Startseite",
    browse: "Hochzeiten entdecken",
    browseWeddings: "Hochzeiten entdecken",
    dashboard: "Dashboard",
    messages: "Nachrichten",
    profile: "Profil",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    admin: "Admin",
  },
  landing: {
    hero: {
      badge: "Der #1 Hochzeits-Erlebnis-Marktplatz",
      title: "Erlebe unvergessliche Hochzeiten weltweit",
      subtitle: "WEDVAYA verbindet Brautpaare mit Reisenden, die authentische kulturelle Erlebnisse suchen. Werden Sie Teil eines besonderen Moments \u2013 als Gastgeber oder als Gast.",
      cta_host: "Als Gastgeber starten",
      cta_guest: "Hochzeiten entdecken",
    },
    trust: {
      freeRegistration: "Kostenlose Registrierung",
      securePayment: "Sichere Zahlung",
      gdprCompliant: "DSGVO-konform",
    },
    stats: {
      weddings: "Hochzeiten",
      worldwide: "weltweit",
      guests: "G\u00e4ste",
      matched: "vermittelt",
      countries: "L\u00e4nder",
      represented: "vertreten",
      rating: "Bewertung",
      average: "Durchschnitt",
    },
    features: {
      title: "Warum WEDVAYA?",
      subtitle: "Wir machen es einfach und sicher, unvergessliche Hochzeitserlebnisse zu teilen.",
      secure: {
        title: "Sichere Zahlungen",
        desc: "Alle Transaktionen sind durch Stripe gesch\u00fctzt. Ihr Geld ist sicher, bis das Event stattfindet.",
      },
      verified: {
        title: "Verifizierte Profile",
        desc: "Optionale Identit\u00e4tspr\u00fcfung f\u00fcr zus\u00e4tzliches Vertrauen zwischen Gastgebern und G\u00e4sten.",
      },
      global: {
        title: "Weltweite Events",
        desc: "Von romantischen Hochzeiten in der Toskana bis zu traditionellen Feiern in Indien.",
      },
      contact: {
        title: "Direkter Kontakt",
        desc: "Nach der Buchung k\u00f6nnen Sie direkt mit Ihrem Gastgeber kommunizieren.",
      },
      gdpr: {
        title: "DSGVO-Konform",
        desc: "Ihre Daten sind sicher. Wir halten uns strikt an europ\u00e4ische Datenschutzrichtlinien.",
      },
      instant: {
        title: "Sofortige Buchung",
        desc: "Schneller Bewerbungsprozess. Innerhalb von 48 Stunden erhalten Sie eine Antwort.",
      },
    },
    howItWorks: {
      title: "So funktioniert's",
      subtitle: "In nur wenigen Schritten zu Ihrem unvergesslichen Erlebnis",
      step1: {
        title: "Hochzeit finden",
        desc: "Durchsuchen Sie unsere Auswahl an einzigartigen Hochzeiten weltweit.",
      },
      step2: {
        title: "Bewerbung senden",
        desc: "Stellen Sie sich dem Brautpaar vor und erz\u00e4hlen Sie, warum Sie teilnehmen m\u00f6chten.",
      },
      step3: {
        title: "Best\u00e4tigung & Zahlung",
        desc: "Nach Genehmigung zahlen Sie sicher online. Erst dann ist Ihr Platz reserviert.",
      },
      step4: {
        title: "Unvergesslich feiern",
        desc: "Erleben Sie eine authentische Hochzeit und schaffen Sie lebenslange Erinnerungen.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "Hochzeit eintragen",
        desc: "Erstellen Sie ein Profil f\u00fcr Ihre Hochzeit mit allen wichtigen Details.",
      },
      step2: {
        title: "Bewerbungen pr\u00fcfen",
        desc: "Schauen Sie sich die Profile interessierter G\u00e4ste an.",
      },
      step3: {
        title: "Geld erhalten",
        desc: "Nach dem Event erhalten Sie 85% der Einnahmen automatisch.",
      },
      step4: {
        title: "Gemeinsam feiern",
        desc: "Teilen Sie Ihren besonderen Tag mit Menschen aus aller Welt.",
      },
    },
    tabs: {
      forGuests: "F\u00fcr G\u00e4ste",
      forHosts: "F\u00fcr Gastgeber",
    },
    testimonials: {
      title: "Was unsere Community sagt",
      subtitle: "Echte Erfahrungen von echten Menschen",
    },
    featured: {
      title: "Aktuelle Hochzeiten",
      subtitle: "Entdecken Sie einzigartige Feiern auf der ganzen Welt",
      viewAll: "Alle anzeigen",
      perPerson: "pro Person",
    },
    cta: {
      title: "Bereit f\u00fcr Ihr unvergessliches Erlebnis?",
      subtitle: "Werde Teil der WEDVAYA Community",
      description: "Ob Sie Ihre Hochzeit mit der Welt teilen m\u00f6chten oder ein einzigartiges Reiseerlebnis suchen \u2013 WEDVAYA macht es m\u00f6glich.",
      button: "Kostenlos registrieren",
      becomeHost: "Jetzt Gastgeber werden",
      learnMore: "Mehr erfahren",
    },
    press: {
      title: "Bekannt aus",
    },
  },
  auth: {
    login: {
      title: "Willkommen zur\u00fcck",
      email: "E-Mail",
      password: "Passwort",
      button: "Anmelden",
      noAccount: "Noch kein Konto?",
      register: "Jetzt registrieren",
      forgotPassword: "Passwort vergessen?",
    },
    register: {
      title: "Konto erstellen",
      name: "Vollst\u00e4ndiger Name",
      email: "E-Mail",
      password: "Passwort",
      role: "Ich m\u00f6chte...",
      roleHost: "Hochzeit veranstalten (Gastgeber)",
      roleGuest: "Hochzeiten besuchen (Gast)",
      terms: "Ich akzeptiere die AGB und Datenschutzerkl\u00e4rung",
      button: "Registrieren",
      hasAccount: "Bereits registriert?",
      login: "Jetzt anmelden",
    },
    forgotPassword: {
      title: "Passwort vergessen?",
      description: "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zur\u00fccksetzen.",
      submit: "Link senden",
      sent: "E-Mail gesendet",
      sentDescription: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie einen Link zum Zur\u00fccksetzen.",
      backToLogin: "Zur\u00fcck zum Login",
    },
    resetPassword: {
      title: "Neues Passwort",
      description: "Geben Sie Ihr neues Passwort ein",
      newPassword: "Neues Passwort",
      confirmPassword: "Passwort best\u00e4tigen",
      submit: "Passwort \u00e4ndern",
      success: "Passwort ge\u00e4ndert!",
      successDesc: "Ihr Passwort wurde erfolgreich ge\u00e4ndert. Sie k\u00f6nnen sich jetzt anmelden.",
      goToLogin: "Zum Login",
      mismatch: "Passw\u00f6rter stimmen nicht \u00fcberein",
      tooShort: "Passwort muss mindestens 6 Zeichen haben",
    },
    verification: {
      verifying: "E-Mail wird verifiziert...",
      pleaseWait: "Bitte warten",
      successTitle: "E-Mail verifiziert!",
      success: "Ihre E-Mail wurde erfolgreich verifiziert!",
      errorTitle: "Verifizierung fehlgeschlagen",
      noToken: "Kein Verifizierungstoken vorhanden",
      goToLogin: "Zum Login",
      tryAgain: "Erneut registrieren",
    },
  },
  dashboard: {
    host: {
      title: "Gastgeber Dashboard",
      myWeddings: "Meine Hochzeiten",
      applications: "Bewerbungen",
      earnings: "Einnahmen",
      messages: "Nachrichten",
      createWedding: "Hochzeit erstellen",
      noWeddings: "Noch keine Hochzeiten erstellt",
    },
    guest: {
      title: "Gast Dashboard",
      myApplications: "Meine Bewerbungen",
      browseWeddings: "Hochzeiten entdecken",
      messages: "Nachrichten",
      profile: "Mein Profil",
    },
  },
  wedding: {
    search: {
      title: "Hochzeiten finden",
      location: "Ort",
      date: "Datum",
      price: "Preis",
      search: "Suchen",
      reset: "Zur\u00fccksetzen",
      noResults: "Keine Hochzeiten gefunden",
    },
    card: {
      slots: "Pl\u00e4tze verf\u00fcgbar",
      perGuest: "pro Gast",
      apply: "Bewerben",
      viewDetails: "Details ansehen",
    },
    detail: {
      about: "\u00dcber diese Hochzeit",
      host: "Gastgeber",
      location: "Ort",
      date: "Datum",
      dresscode: "Dresscode",
      price: "Preis pro Gast",
      slots: "Verf\u00fcgbare Pl\u00e4tze",
      apply: "Jetzt bewerben",
      alreadyApplied: "Bereits beworben",
    },
    create: {
      title: "Neue Hochzeit erstellen",
      titleField: "Titel",
      description: "Beschreibung",
      location: "Ort",
      country: "Land",
      date: "Datum",
      dresscode: "Dresscode",
      price: "Preis pro Gast",
      slots: "Anzahl G\u00e4ste",
      currency: "W\u00e4hrung",
      submit: "Hochzeit erstellen",
    },
    verification: {
      badge: "Verifizierung",
      pending: "Warte auf Verifizierung",
      pendingDesc: "Deine Hochzeit wird derzeit vom Team gepr\u00fcft. Sie ist noch nicht \u00f6ffentlich sichtbar.",
      verified: "Verifiziert",
      verifiedDesc: "Deine Identit\u00e4t wurde best\u00e4tigt. Deine Hochzeit ist jetzt \u00f6ffentlich sichtbar.",
      rejected: "Verifizierung abgelehnt",
      rejectedDesc: "Deine Verifizierung wurde abgelehnt. Bitte lade erneut hoch:",
      rejectedReason: "Grund: {reason}",
      uploadTitle: "Identit\u00e4tsnachweis hochladen",
      uploadDesc: "Um Betrug zu verhindern, muss die Identit\u00e4t des Brautpaars vor der Ver\u00f6ffentlichung best\u00e4tigt werden. Lade Dokumente hoch, die deinen Namen und eure Ehe/Heirat nachweisen.",
      docType: "Dokumententyp",
      docTypeSelect: "Dokument ausw\u00e4hlen",
      docTypeIdFront: "Ausweis Vorderseite",
      docTypeIdBack: "Ausweis R\u00fcckseite",
      docTypeMarriageCert: "Heiratszertifikat",
      docTypeMarriageReg: "Heiratsregister",
      uploadButton: "Dokument hochladen",
      uploading: "Wird hochgeladen...",
      uploadSuccess: "Dokument hochgeladen",
      uploadError: "Hochladen fehlgeschlagen",
      requirement: "Mindestens ein Ausweis (Vorderseite) und ein Heiratsnachweis sind erforderlich.",
      reUpload: "Erneut hochladen",
      uploaded: "Hochgeladen",
      incomplete: "Unvollständig",
      completeHint: "Laden Sie mindestens einen Ausweis (Vorderseite) und einen Heiratsnachweis hoch, um die Verifizierung abzuschließen",
      submit: "Verifizierung einreichen",
    },
  },
  application: {
    status: {
      pending: "Ausstehend",
      approved: "Genehmigt",
      rejected: "Abgelehnt",
    },
    payment: {
      pending: "Zahlung ausstehend",
      paid: "Bezahlt",
      pay: "Jetzt bezahlen",
    },
    approve: "Genehmigen",
    reject: "Ablehnen",
  },
  review: {
    title: "Bewertung schreiben",
    description: "Teile deine Erfahrung mit",
    ratingLabel: "Wie würdest du deine Erfahrung bewerten?",
    rating1: "Schlecht",
    rating2: "Ausreichend",
    rating3: "Gut",
    rating4: "Sehr gut",
    rating5: "Ausgezeichnet",
    commentLabel: "Deine Bewertung",
    optional: "optional",
    commentPlaceholder: "Erzähle anderen von deiner Erfahrung...",
    for: "Bewertung für",
    submit: "Bewertung absenden",
    success: "Bewertung erfolgreich eingereicht!",
    error: "Bewertung konnte nicht eingereicht werden",
    selectRating: "Bitte wähle eine Bewertung",
    noReviews: "Noch keine Bewertungen",
    received: "Erhaltene Bewertungen",
    averageRating: "Durchschnittsbewertung",
    writeReview: "Bewertung schreiben",
    reviewed: "Bewertet",
    completedWedding: "Diese Hochzeit wurde abgeschlossen. Du kannst jetzt eine Bewertung schreiben.",
  },
  messages: {
    title: "Nachrichten",
    noMessages: "Keine Nachrichten",
    placeholder: "Nachricht schreiben...",
    send: "Senden",
  },
  admin: {
    title: "Admin Dashboard",
    stats: {
      users: "Benutzer",
      hosts: "Gastgeber",
      guests: "G\u00e4ste",
      weddings: "Hochzeiten",
      activeWeddings: "Aktive Hochzeiten",
      applications: "Bewerbungen",
      revenue: "Gesamtumsatz",
      platformEarnings: "Plattform-Einnahmen",
    },
    tabs: {
      overview: "\u00dcbersicht",
      users: "Benutzer",
      weddings: "Hochzeiten",
      transactions: "Transaktionen",
    },
    actions: {
      ban: "Sperren",
      unban: "Entsperren",
      feature: "Hervorheben",
      unfeature: "Hervorhebung entfernen",
    },
  },
  common: {
    loading: "Laden...",
    error: "Ein Fehler ist aufgetreten",
    success: "Erfolgreich",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "L\u00f6schen",
    edit: "Bearbeiten",
    back: "Zur\u00fcck",
    next: "Weiter",
    language: "Sprache",
    currency: "W\u00e4hrung",
  },
  footer: {
    about: "\u00dcber uns",
    privacy: "Datenschutz",
    terms: "AGB",
    contact: "Kontakt",
    description: "Der globale Marktplatz f\u00fcr unvergessliche Hochzeitserlebnisse.",
    copyright: "\u00a9 2024 WEDVAYA. Alle Rechte vorbehalten.",
  },
  notifications: {
    title: "Benachrichtigungen",
    empty: "Keine Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
  },
  chat: {
    conversations: "Gespr\u00e4che",
    search: "Gespr\u00e4che durchsuchen...",
    noConversations: "Noch keine Gespr\u00e4che",
    selectConversation: "W\u00e4hlen Sie ein Gespr\u00e4ch",
    selectConversationDesc: "W\u00e4hlen Sie ein Gespr\u00e4ch aus der Liste, um zu chatten",
    online: "Online",
    offline: "Offline",
    connecting: "Verbinden...",
    noMessages: "Noch keine Nachrichten",
    startConversation: "Starten Sie das Gespr\u00e4ch!",
    placeholder: "Nachricht eingeben...",
    you: "Du",
  },
  cookies: {
    title: "Wir verwenden Cookies",
    description: "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, den Datenverkehr zu analysieren und f\u00fcr Marketingzwecke.",
    acceptAll: "Alle akzeptieren",
    rejectAll: "Alle ablehnen",
    customize: "Anpassen",
    settingsTitle: "Cookie-Einstellungen",
    functional: "Funktionale Cookies",
    functionalDesc: "Erforderlich f\u00fcr die ordnungsgem\u00e4\u00dfe Funktion der Website.",
    analytics: "Analyse-Cookies",
    analyticsDesc: "Helfen uns zu verstehen, wie Besucher mit der Website interagieren.",
    marketing: "Marketing-Cookies",
    marketingDesc: "Werden verwendet, um personalisierte Werbung zu liefern.",
    saveSettings: "Einstellungen speichern",
  },
};

export default de;
